import { ExperienceVerificationStatusType } from '@apply/constants';
import { UserActionReturns } from './actions';
import * as Types from './types';

export const userReducer = (state: Types.UserState = Types.userInitialState, action: UserActionReturns): Types.UserState => {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { type, payload } = action as any;

    switch (type) {
        case Types.UPDATE_USER_APPLICATIONS: {
            const sorted: Types.UserApplication[] = [...payload.applications].sort(
                (a, b) => b.lastModified.valueOf() - a.lastModified.valueOf()
            );
            const completedApplications = sorted.filter((a) => a.complete);
            const inProgressApplications = sorted.filter((a) => !a.complete);
            return {
                ...state,
                completedApplications,
                inProgressApplications,
            };
        }
        case Types.UPDATE_USER_NOTICES: {
            const userNotices: Types.UserNoticeLean[] = [...payload.notices];
            return {
                ...state,
                userNotices,
            };
        }
        case Types.UPDATE_USER_NOTICE_COUNTS: {
            const noticeCounts: Types.UserNoticeCounts = {
                ...payload.noticeCounts,
            };
            return {
                ...state,
                noticeCounts,
            };
        }
        case Types.UPDATE_USER_NOTICE: {
            const userNotice: Types.UserNotice = { ...payload.userNotice };
            return {
                ...state,
                userNotice,
            };
        }
        case Types.SIGN_USER_NOTICE: {
            const signedNotice: Types.SignUserNotice = {
                ...payload.signedNotice,
            };
            return {
                ...state,
                signedNotice,
            };
        }
        case Types.UPDATE_USER_EXPERIENCES: {
            const experiences: Types.UserExperienceGridRecord[] = [...payload.experiences];

            const activeExperiences = experiences.filter(
                (a) =>
                    a.verificationStatusTypeId !== ExperienceVerificationStatusType.UnableToVerify &&
                    a.verificationStatusTypeId !== ExperienceVerificationStatusType.Rejected
            );
            const unverifiableExperiences = experiences.filter(
                (a) =>
                    a.verificationStatusTypeId === ExperienceVerificationStatusType.UnableToVerify ||
                    a.verificationStatusTypeId === ExperienceVerificationStatusType.Rejected
            );
            const applicableProvidedExperienceCount = activeExperiences.filter(
                (a) => a.projectTypeId !== Types.ExperienceProjectType.PersonalResidence
            ).length;
            return {
                ...state,
                activeExperiences,
                unverifiableExperiences,
                applicableProvidedExperienceCount,
            };
        }
        default: {
            return state;
        }
    }
};
